import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';

export interface HardwarePackagesTableFilter {
  sort?: string;
}

export type HardwarePackagesFilterWithPaginationShape = FilterWithPaginationStateShape<HardwarePackagesTableFilter>;

const STATE_KEY = 'HardwarePackagesFilterState' as const;

export const DEFAULT_FILTER = {
  sort: 'id:desc',
};

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: DEFAULT_PAGINATION,
});

export const useHWPackagesFilterWithPagination = (): HardwarePackagesFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
